/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liveroomfeature2Inputs */

const en_liveroomfeature2 = /** @type {(inputs: Liveroomfeature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room`)
};

const de_liveroomfeature2 = /** @type {(inputs: Liveroomfeature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room`)
};

/**
* | output |
* | --- |
* | "Live Room" |
*
* @param {Liveroomfeature2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomfeature2 = /** @type {((inputs?: Liveroomfeature2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomfeature2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomfeature2(inputs)
	return de_liveroomfeature2(inputs)
});
export { liveroomfeature2 as "liveRoomFeature" }